import { call, put, takeLatest } from "redux-saga/effects";
import { GET_ApprovalToMe, GET_ApprovalByMe, POST_ApprovalDecide } from "../services/Approval";
import exception from "../utils/exception";
import { jwtDecode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_ApprovalToMeEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_ApprovalToMe, token, payload);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_ApprovalToMe", payload: resData.data });
    if (callback) callback(resData.data);
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_ApprovalByMeEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_ApprovalByMe, token, payload);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_ApprovalByMe", payload: resData.data });
    if (callback) callback(resData.data);
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_ApprovalDecideEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(POST_ApprovalDecide, token, payload);
    if (res) { /* 無需解碼 */ }
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* ApprovalSaga() {
  yield takeLatest("GET_ApprovalToMe", GET_ApprovalToMeEffect);
  yield takeLatest("GET_ApprovalByMe", GET_ApprovalByMeEffect);
  yield takeLatest("POST_ApprovalDecide", POST_ApprovalDecideEffect);
}
